import * as React from 'react';
import { PageDataProvider } from '@bernie/page-context';
function PageDataPlugin() {
  return {
    name: 'pagedata',
    onBrowserHydrateRenderContext: function (context, next) {
      var hydratedState = context.hydratedState,
        setAppData = context.setAppData;
      var pageDataContext = hydratedState.pageDataContext;
      setAppData({
        pageDataContext: pageDataContext
      });
      return next(context);
    },
    onBrowserWrapRootElement: function (context, next) {
      var getAppData = context.getAppData,
        setRootElement = context.setRootElement;
      var pageDataContext = getAppData().pageDataContext;
      setRootElement(function (RootElement) {
        return function (props) {
          return React.createElement(PageDataProvider, {
            pageDataContext: pageDataContext
          }, React.createElement(RootElement, null, props.children));
        };
      });
      return next(context);
    }
  };
}
export { PageDataPlugin as default };